import React from 'react';

import TextShortenIcon from '@atlaskit/icon/core/text-shorten';

export const MakeShorterIcon = () => (
	<TextShortenIcon label="" color="currentColor" spacing="spacious" />
);
